import { Drawer, type DrawerProps } from 'antd';
import { memo, type FC } from 'react';
import styles from './index.module.scss';

const TurbosDrawer: FC<DrawerProps> = (props) => {
  return (
    <Drawer rootClassName={styles.root_class} title={null} closable={false} {...props}></Drawer>
  );
};

export default memo(TurbosDrawer);
